import React from "react";
import styles from "./arenamajubarretos.module.scss";

const WA = "5516991414590";

const links = [
  {
    label: "Agendamento Eventos",
    href: `https://wa.me/${WA}?text=${encodeURIComponent(
      "Olá! Vim pelo link da bio e gostaria de mais informações sobre a locação para eventos.",
    )}`,
  },
  {
    label: "Agendamento Futevôlei",
    href: `https://wa.me/${WA}?text=${encodeURIComponent(
      "Olá! Vim pelo link da bio e gostaria de mais informações sobre as aulas de futevôlei.",
    )}`,
  },
  {
    label: "Agendamento Quadra",
    href: `https://wa.me/${WA}?text=${encodeURIComponent(
      "Olá! Vim pelo link da bio e gostaria de mais informações sobre a locação de quadra.",
    )}`,
  },
  {
    label: "Localização",
    href: "https://maps.app.goo.gl/yTJjx79YxQWd7bXX6",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/arenamaju.barretos?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  },
];

const Arenamajubarretos: React.FC = () => (
  <div className={styles.arenamajubarretos}>
    <main className={styles.main}>
      <div className={styles.logoWrap}>
        <img
          className={styles.logo}
          src={require("./src/logo.png")}
          alt="Arena Maju Barretos"
        />
      </div>

      <nav className={styles.nav} aria-label="Links Arena Maju">
        {links.map(({ label, href }) => (
          <a
            key={label}
            className={styles.button}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.buttonLabel}>{label}</span>
          </a>
        ))}
      </nav>
    </main>
  </div>
);

export default Arenamajubarretos;
